// Shared pdf.js setup for the PDF-signature-fields feature (placement tool +
// supplier signing view). pdf.js needs a worker; we point it at a version-
// matched copy on a CDN so there's no CRA worker-bundling config to maintain.
// The app is always online where the PDF viewer is used (admin + portal), so a
// CDN worker is fine here — the stored/standalone signed documents are separate.
// The LEGACY build is transpiled for older toolchains (CRA / react-scripts 5),
// where the default modern ESM build can fail at runtime. The worker is served
// SAME-ORIGIN from public/ (copied from pdfjs-dist/legacy/build), because
// loading it as a cross-origin dynamically-imported module fails ("Setting up
// fake worker failed"). Keep public/pdf.worker.min.mjs in sync with the
// installed pdfjs-dist version on upgrade.
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';

pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ''}/pdf.worker.min.mjs`;

export default pdfjsLib;
